// LabelRanking.tsx
import { Chip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from 'constants/theme'
import _ from 'lodash'
import { getMember } from 'utils/app.utils'

type RankType = {
  rankId?: number
  disabled?: boolean
  textTransform?: 'uppercase' | 'lowercase' | 'capitalize'
  compact?: boolean
}

const Ranking = styled(
  Chip,
  {
    shouldForwardProp: (prop) => prop !== 'disabled' && prop !== 'compact',
  }
)<{ disabled?: boolean; compact?: boolean }>(({ theme, disabled, compact }) => ({
  height: compact ? 20 : 29,
  borderRadius: 4,
  '& .MuiChip-label': {
    fontSize: compact ? 12 : 16,
    fontWeight: 600,
    color: disabled ? colors.disabledGray : colors.white,
    padding: compact ? '0 8px' : undefined,
  },
  [theme.breakpoints.down('sm')]: {
    height: compact ? 18 : 24,
    '& .MuiChip-label': {
      fontSize: compact ? 11 : 14,
    },
  },
}))

export default function LabelRanking({
  rankId,
  disabled = false,
  textTransform = 'uppercase',
  compact = false,
}: RankType) {
  const memberAll = getMember()
  const rankData = _.find(memberAll, { rankId })

  return (
    <Ranking
      label={rankData ? rankData.rankName : 'RANKING MEMBER'}
      size="small"
      disabled={disabled}
      compact={compact}
      sx={{
        bgcolor: disabled
          ? colors.lightGray
          : rankData
            ? rankData.color
            : colors.backdrop,
        textTransform,
      }}
    />
  )
}
